<template>
    <v-container class="services grid-list-lg">
        <h3 class="align-left mb-4">{{title}}</h3>
        <v-layout row wrap align-end>
            <v-flex xs12 md6 lg4 py-0>
                <osago-name
                    v-model="person.fio.surname"
                    label="Фамилия"
                />
            </v-flex>
            <v-flex xs12 md6 lg4 py-0>
                <osago-name
                    v-model="person.fio.name"
                    label="Имя"
                />
            </v-flex>
            <v-flex xs12 md6 lg4 py-0>
                <osago-name
                    v-model="person.fio.patronymic"
                    label="Отчество"
                    optional="true"
                    :noField.sync="person.fio.noPatronymic"
                    genitiveLabel="отчества"
                />
                <osago-gender
                    v-if="person.fio.noPatronymic"
                    v-model="person.gender"
                    label="Пол"
                    :noField.sync="person.gender"
                />
            </v-flex>
            <v-flex xs12 sm6 lg4 py-0>
                <osago-date
                    v-model="person.birthday"
                    label="Дата рождения"
                    isBirthday="true"
                    :max="dateDriversMinimal"
                    :isHideMobile="true"
                />
            </v-flex>
        </v-layout>
        <v-layout row wrap pt-1>
            <v-flex xs12>
                <h4 style="display: inline; margin: 5px 0 -5px;">Паспорт</h4>
            </v-flex>
            <v-flex xs12 sm6 md3 lg3 py-0>
                <v-text-field
                    v-model="person.passport.seriesNumber"
                    :rules="[rules.passport]"
                    label="Серия и номер"
                    mask="#### ######"
                    return-masked-value
                    validation-on-blur
                />
            </v-flex>
            <v-flex xs12 sm6 md3 lg3 py-0>
                <osago-date
                    label="Дата выдачи"
                    v-model="person.passport.date"
                    :passportAgeCheck="person.dateDriverPassport"
                    :min="person.dateDriverPassport"
                    :max="dateToday"
                    :isHideMobile="true"
                />
            </v-flex>
            <v-flex xs12 md6 lg6 py-0>
                <v-text-field
                    label="Кем выдан"
                    v-model="person.passport.issuedBy"
                />
            </v-flex>

            <v-flex xs12>
                <h4 style="display: inline; margin: 5px 0 -5px;">Адрес регистрации</h4>
            </v-flex>
            <v-flex xs12 py-0>
                <v-text-field
                    label="Гoрод, улица, дом, квартира"
                    v-model="person.address"
                    :goToElement="false"
                />
            </v-flex>
        </v-layout>
        <v-layout row wrap v-if="ownerIsNotBuyer && person.role == 'seller'">
            <v-flex xs12>
                <h4 style="display: inline; margin: 5px 0 -5px;">Доверенность</h4>
            </v-flex>
            <v-flex xs12 sm6 md3 lg3 py-0>
                <v-text-field
                    label="Номер доверенности"
                    v-model="person.procuratory.number"
                    :rules="[rules.numbers]"
                />
            </v-flex>
            <v-flex xs12 sm6 md3 lg3 py-0>
                <osago-date
                    label="Дата выдачи"
                    v-model="person.procuratory.date"
                    :max="dateToday"
                />
            </v-flex>
            <v-flex xs12 md6 py-0>
                <v-text-field
                    label="ФИО нотариуса"
                    v-model="person.procuratory.fio"
                />
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import moment from 'moment';

    export default {
        props: ['person', 'title', 'ownerIsNotBuyer'],
        data:() => ({
            rules: {
                required: v => !!v || 'Обязательное поле',
                passport: v => /^\d{4} \d{6}$/.test(v) || 'Неверный формат',
                numbers: v => /^[АВЕКМНОРСТУХ_\d\s]*$/.test(v) || 'Неверный формат',
            },
            dateDriversMinimal: '',
            dateToday: '',
        }),

        created: function(){
            this.dateToday = moment().format('YYYY-MM-DD')
            this.dateDriversMinimal = moment().subtract(18, 'years').format('YYYY-MM-DD')
        },

        methods: {
            setPassportIssuedBy(person) {
                if (person.passport.seriesNumber) {
                    person.passport.issuedBy = 'МВД РФ';
                }
            },
        }
    }
</script>
<style scoped>
    h3{
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/services/ServicePersonForm.vue